module.exports = __webpack_public_path__ + "img/content4.6bd19113.png";